export const CHROME = 'CHROME';
export const FIREFOX = 'FIREFOX';
export const SAFARI = 'SAFARI';
export const IE = 'IE';
export const OPERA = 'OPERA';
export const MOBILE = 'MOBILE';
export const IPAD = 'IPAD';
export const EDGE = 'EDGE';
export const CHROME_IOS = 'CHROME_IOS';
export const FIREFOX_IOS = 'FIREFOX_IOS';
export const VERSION = 'VERSION';
export const MSIE = 'MSIE';
export const CRIOS = 'CRIOS';
export const FXIOS = 'FXIOS';
